import Close from './Close';
import CloseArrow from './CloseArrow';
import MannySmall from './MannySmall';
import Loading from './Loading';
import OpenNew from './OpenNew';
import Search from './Search';

export { Close, CloseArrow, MannySmall, Loading, OpenNew, Search };



// WEBPACK FOOTER //
// ./src/components/Icons/index.js